import { post } from '@/utils';
import { ApiResponse } from '@/utils';
import { ProductListParams, ProductListResponse } from '../types';

/**
 * 产品服务
 * 用于获取产品套餐列表等
 */
class ProductService {
  /**
   * 获取产品套餐列表
   * @param params 请求参数 { type, price_asc? }
   * @returns 套餐列表
   */
  async getProductList(params: ProductListParams): Promise<ApiResponse<ProductListResponse>> {
    return post<ProductListResponse>('/product/list', params);
  }
}

export const productService = new ProductService();
